<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->
<template>
  <div class="commodity-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick"></Menus>
    <PopupEntry 
    v-if="popupEntryShow" 
    :show.sync="popupEntryShow" 
    :title="titleCommodity" 
    @save="saveCommodity"
      :requiredError="entryError" 
      :errorMessages="errorMessage" 
      :viewMode="viewMode"
      @requiredClicked="errorMessageClicked" 
      :successMessages="successMessages" 
      :updatedBy="updatedBy"
      :createdBy="createdBy">

      <Input placeholder="Commodity Code" 
      :isDisabled="disableCommodityCode" 
      :inputValue.sync="commodityCode"
      :isRequired="true" 
      validator="alphanumeric,10,uppercase" 
      ref="commodityCode"
      :errorMessage.sync="commodityCodeError" />

      <CheckBoxV2 title="Dangerous Cargo"
        :isChecked.sync="DGCargo" 
        :isDisabled="disableDGCargo" 
        ref="DGCargo"/>

      <InputQuery 
      placeholder="Class" 
      :isDisabled="disableClass" 
      :items="ClassList" 
      itemKey="ID"
      descKey="Proper Ship Name"
      :selectedObject.sync="selectedClass"
      @selected = "handleClassSelected"
      ref="Class"></InputQuery>

      <Input placeholder="Description" 
      :isDisabled=" disableCommodityDescription" 
      :inputValue.sync="commodityDescription"
      ref="commodityDescription" 
      :errorMessage.sync="commodityDescriptionError" 
      validator="text,300,,alphanumeric,all"/>

      <Input placeholder="IMO" 
      :isDisabled="disableIMO" 
      :inputValue.sync="IMO"
      ref="IMO" 
      :errorMessage.sync="IMOError" 
      validator="text,5,,alphanumeric,all"/>

      <div class="flex-row">
        <Input placeholder="Flash Point" 
        :isDisabled="disableFlashPoint" 
        :inputValue.sync="flashPoint" 
        ref="flashPoint"
        :errorMessage.sync="flashPointError"
        validator="text,10,uppercase,alphanumeric,all" />

        <Input placeholder="NA #" 
        :isDisabled="disableNaNo" 
        :inputValue.sync="NaNo" 
        ref="NaNo" 
        :errorMessage.sync="NaNoError"
        validator="text,8,uppercase,alphanumeric,all"/>
      </div>

      <div class="flex-row">
        <Input placeholder="UN #" 
        :isDisabled="disableUNNo" 
        :inputValue.sync="UNNo"  
        ref="UNNo" 
        :errorMessage.sync="UNNoError"
        validator="text,8,uppercase,alphanumeric,all"/>

        <Input placeholder="EMS #" 
        :isDisabled="disableEMSNo" 
        :inputValue.sync="EMSNo" 
        ref="EMSNo" 
        :errorMessage.sync="EMSNoError"
        validator="text,25,uppercase,alphanumeric,all"/>
      </div>

      <div class="flex-row">
        <Input placeholder="Precooling Period" 
        :isDisabled="disablePrecoolingPeriod" 
        :inputValue.sync="precoolingPeriod" 
        ref="precoolingPeriod" 
        :errorMessage.sync="precoolingPeriodError"
        validator="text,20,,alphanumeric,all"/>

        <Input placeholder="MFAG #" 
        :isDisabled="disableMFAGNo" 
        :inputValue.sync="MFAGNo" 
        ref="MFAGNo" 
        :errorMessage.sync="MFAGNoError"
        validator="text,25,uppercase,alphanumeric,all"/>
      </div>

      <Input placeholder="Packaging Group" 
      :isDisabled="disablePackagingGroup" 
      :inputValue.sync="packagingGroup"
      ref="packagingGroup" 
      :errorMessage.sync="packagingGroupError"
      validator="text,10,,alphanumeric,all"/>

      <RadioButtonSet class="radio-button-set-component" 
      title="Type" 
      :buttons="TypeButton" 
      labelKey="label"
      :selected.sync="selectedType" 
      :isDisabled="disableselectedType" 
      :isHorizontal="true" />
      
      <Input placeholder="Placard" 
      :isDisabled="disablePlacard" 
      :inputValue.sync="Placard"
      ref="Placard" 
      :errorMessage.sync="placardError"
      validator="text,10,uppercase,alphanumeric,all" 
      style="margin-top: 6px;"/>

      <Input placeholder="Technical Name" 
      :isDisabled="disableTechnicalName" 
      :inputValue.sync="technicalName" 
      ref="technicalName" 
      :errorMessage.sync="technicalNameError"
      validator="text,50,,alphanumeric,all" />

    </PopupEntry>

    <div class="right-container">
      <TableBox title="Commodity" :tableData="commodityList" :selectedRow.sync="selectedCommodity"></TableBox>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function () {
    return {
      menus: [
        {
          title: "New Commodity",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png",
          key: "MnuNew",
          visible: true,
          enabled: true
        },
        {
          title: "Edit Commodity",
          icon:
            "https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png",
          key: "MnuEdit",
          visible: true,
          enabled: true
        },
        {
          title: "Delete Commodity",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png",
          key: "MnuDelete",
          visible: false,
          enabled: true
        },
        {
          title: "View Commodity",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png",
          key: "MnuQuery",
          visible: true,
          enabled: true
        }
      ],
      // Data properties
      commodityCode: "",
      commodityDescription: "",
      IMO: "",
      UNNo: "",
      flashPoint: "",
      NaNo: "",
      EMSNo: "",
      MFAGNo:"",
      Placard:"",
      technicalName:"",
      precoolingPeriod:"",
      packagingGroup: "",
      DGCargo: false,
      selectedType: null,
      TypeButton: [
        { label: "Solid", keyValue: "0" },
        { label: "Liquid", keyValue: "1" },
        { label: "Gas", keyValue: "2" }
      ],
      createdBy: "",
      updatedBy: "",

      // Flags for disabling fields
      disableCommodityCode: false,
      disableCommodityDescription: false,
      disableIMO: false,
      disableClass: false,
      disableUNNo: false,
      disableFlashPoint: false,
      disableNaNo: false,
      disableEMSNo: false,
      disableMFAGNo:false,
      disablePlacard:false,
      disableTechnicalName:false,
      disablePrecoolingPeriod:false,
      disablePackagingGroup: false,
      disableDGCargo: false,
      disableselectedType: false,
      // Popup settings
      popupEntryShow: false,
      titleCommodity: "",
      entryError: [],
      errorMessage: [],
      successMessages: [],
      viewMode: false,
      saveOption: "",
      // Selected rows and lists
      selectedCommodity: [],
      commodityList: [],
      ClassList: [],
      //query selected data
      selectedClass: null,
      // Error messages
      commodityDescriptionError: "",
      commodityCodeError: "",
      IMOError: "",
      UNNoError: "",
      flashPointError: "",
      NaNoError: "",
      EMSNoError: "",
      MFAGNoError:"",
      placardError:"",
      technicalNameError:"",
      precoolingPeriodError:"",
      packagingGroupError: ""
    };
  },

  methods: {
    errorMessageClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    clearErrorMessages: function () {
      this.commodityDescriptionError = "";
      this.commodityCodeError = "";
      this.IMOError= "";
      this.UNNoError= "";
      this.flashPointError= "";
      this.NaNoError= "";
      this.EMSNoError= "";
      this.MFAGNoError="";
      this.placardError="";
      this.technicalNameError="";
      this.precoolingPeriodError="";
      this.packagingGroupError= "";
    },
    getSpecificCommodity: async function (record) {
      this.$fullscreenLoading("Getting Details");
      let details = (
        await this.$apiCallV2(`/Master/GetDetailsMaster`, {
          masterfile: "COMMODITY",
          recordid: record
        })
      )["Commodity"];
      this.commodityCode = details["CommodityCode"];
      this.commodityDescription = details["CommodityDescription"];
      this.selectedClass = this.ClassList.getSelected(
        details["HazMatCFRID"],
        "ID"
      );
      this.IMO = details["IMO"];
      this.UNNo = details["UNNo"];
      this.flashPoint = details["FlashPoint"];
      this.NaNo = details["NaNo"];
      this.EMSNo = details["EMSNo"];
      this.MFAGNo = details["MFAGNo"];
      this.Placard = details["Placard"];
      this.technicalName = details["TechnicalName"];
      this.precoolingPeriod = details["PrecoolingPeriod"];
      this.packagingGroup = details["PackagingGroup"];
      this.DGCargo = details["DGCargo"] == "1";
      this.selectedType = this.TypeButton.find(
        (btn) => btn.keyValue === details["Type"]
      );
      
      this.createdBy = `${details["UserCreated"] || ""} ${details["TimeCreated"]
        ? new Date(details["TimeCreated"]).formatString("dd/MM/yyyy HH:mm")
        : ""
        }`;
      this.updatedBy = `${details["UserID"] || ""} ${details["DateUpdated"]
        ? new Date(details["DateUpdated"]).formatString("dd/MM/yyyy HH:mm")
        : ""
        }`;
      this.$fullscreenLoading();
    },
    getHazMatCFRList: async function () {
      this.$fullscreenLoading("Getting Details");
      this.ClassList = await this.$apiCallV2("/Master/GetListMaster", {
        masterfile: "HAZMATCFR"
      });
      this.$fullscreenLoading();
    },
    getAllCommodityDetails: async function () {
      this.$fullscreenLoading("Getting Details");
      this.commodityList = [];
      this.commodityList = await this.$apiCallV2("/Master/GetListMaster", {
        masterfile: "COMMODITY"
      });
      this.$fullscreenLoading();
    },
    clearInputFields: function () {
      this.commodityCode = "";
      this.commodityDescription = "";
      this.IMO = "",
      this.UNNo = "";
      this.flashPoint = "",
      this.NaNo = "",
      this.EMSNo = "",
      this.MFAGNo = "",
      this.Placard = "",
      this.technicalName = "",
      this.precoolingPeriod = "",
      this.packagingGroup = "",
      this.DGCargo = false,
      this.selectedType = null,
      this.selectedClass = null;
      this.createdBy = "";
      this.updatedBy = "";
    },
    handleClassSelected: function (newVal) {
      if (newVal) {
        this.IMO = newVal['Hazard Class Division'] || '';
        this.UNNo = newVal['UNNO'] || '';
        if (!this.commodityDescription.trim()){
          this.commodityDescription = newVal['Proper Ship Name'] || '';
        }
        this.packagingGroup = newVal['Packaging Group'] || '';
      } else {
        this.IMO = '';
        this.UNNo = '';
        this.commodityDescription = '';
        this.packagingGroup = '';
      }
    },
    handleMenuClick: async function (menu) {
      this.errorMessage = [];
      this.entryError = [];
      this.successMessages = [];
      this.clearErrorMessages();

      switch (menu.title) {
        case "View Commodity":
          if (this.selectedCommodity.length == 0) {
            this.$showAlert(
              "error",
              "No Commodity Selected",
              "Please select a record to view"
            );
          } else {
            await this.getSpecificCommodity(
              this.selectedCommodity[0]["Commodity Code"]
            );
            this.disablePopupEntryFields();
            this.viewMode = true;
            this.titleCommodity = "View Commodity";
            this.popupEntryShow = true;
          }
          break;
        case "Edit Commodity":
          if (this.selectedCommodity.length == 0) {
            this.$showAlert(
              "error",
              "No Commodity Selected",
              "Please select a record to edit"
            );
          } else {
            await this.getSpecificCommodity(
              this.selectedCommodity[0]["Commodity Code"]
            );
            this.saveOption = "E";
            this.enablePopupEntryFields();
            this.disableCommodityCode = true;
            this.viewMode = false;
            this.titleCommodity = "Edit Commodity";
            this.popupEntryShow = true;
            this.$nextTick(() => {
              this.$refs["DGCargo"].setFocus();
            });
          }
          break;
        case "New Commodity":
          this.clearInputFields();
          this.enablePopupEntryFields();
          this.disableCommodityCode = false;
          this.viewMode = false;
          this.saveOption = "N";
          this.selectedType = this.TypeButton.find((btn) => btn.keyValue === "0");
          this.titleCommodity = "New Commodity";
          this.popupEntryShow = true;
          this.$nextTick(() => {
            this.$refs["commodityCode"].setFocus();
          });
          break;
        case "Delete Commodity":
          if (!this.selectedCommodity.length) {
            this.$showAlert(
              "error",
              "No Commodity Selected",
              "Please select a record to delete"
            );
            return;
          }
          let deleting = await this.$showAlert(
            "warning",
            "Delete Commodity",
            `Are you sure you want to delete Commodity Code ${this.selectedCommodity[0]["Commodity Code"]
            }?`,
            [
              { text: "Delete", textColor: "white", color: "red" },
              { text: "Cancel", textColor: "black", color: "lightgray" }
            ]
          );

          if (deleting == "Cancel") {
            return;
          }

          this.$fullscreenLoading("Deleting Commodity");
          let result = await this.$apiCallV2("/Commodity/SaveCommodity", {
            action: "D",
            commoditycode: this.selectedCommodity[0]["Commodity Code"]
          });
          this.$fullscreenLoading();
          if (result[0]["Results"] == 0) {
            this.$showAlert(
              "success",
              "Commodity Code Deleted",
              `Successfully deleted Commodity Code ${
              this.selectedCommodity[0]["Commodity Code"]
              }`
            );
            this.$nextTick(async () => await this.getAllCommodityDetails());
            this.selectedCommodity = [];
            return;
          } else {
            
            this.$showAlert(
              "error",
              "Commodity NOT Deleted",
              `${result[0]["ErrMsg"]}`
            );
          }
      
          break;
      }
    },
    saveCommodity: async function () {
      this.entryError = [];
      this.errorMessage = [];
      let isValid = this.checkFields();
      if (isValid) {
        let dataToPost = {
          commoditycode: this.commodityCode,
          commoditydescription: this.commodityDescription,
          hazmatcfrid: this.selectedClass ? this.selectedClass.ID : '',
          imo : this.IMO,
          unno: this.UNNo,
          nano: this.NaNo,
          flashpoint: this.flashPoint,
          emsno: this.EMSNo,
          precoolingperiod: this.precoolingPeriod,
          mfagno: this.MFAGNo,
          packaginggroup: this.packagingGroup,
          dgcargo: (this.DGCargo) ? 1 : 0,
          type: this.selectedType ? this.selectedType.keyValue: null,
          placard: this.Placard,
          technicalname: this.technicalName,
          action: this.saveOption
        };

        this.$fullscreenLoading("Saving Commodity");
        let postUpdate = await this.$apiCallV2(
          "/Commodity/SaveCommodity",
          dataToPost
        );
        this.$fullscreenLoading();

        if (postUpdate[0].Results >= 1) {
          this.errorMessage.push(postUpdate[0].ErrMsg);
        } else {
          if (this.saveOption == "N") {
            this.successMessages.push(
              "Successfully created Commodity Code: " + this.commodityCode
            );
          }
          if (this.saveOption == "E") {
            this.successMessages.push(
              "Successfully edited Commodity Code: " + this.commodityCode
            );
          }
          this.viewMode = true;
          this.disablePopupEntryFields();
          this.titleCommodity = "View Commodity";
          await this.getAllCommodityDetails();
        }
      }
    },
    enablePopupEntryFields: function() {
        this.disableCommodityDescription = false;
        this.disableClass = false;
        this.disableFlashPoint = false;
        this.disableUNNo = false;
        this.disableNaNo = false;
        this.disableEMSNo = false;
        this.disableTechnicalName = false;
        this.disableMFAGNo = false;
        this.disablePrecoolingPeriod = false;
        this.disablePackagingGroup = false;
        this.disableIMO = false;
        this.disableDGCargo = false;
        this.disablePlacard = false;
        this.disableselectedType = false;
    },
    disablePopupEntryFields: function() {
        this.disableCommodityDescription = true;
        this.disableCommodityCode = true;
        this.disableIMO = true;
        this.disableClass = true;
        this.disableUNNo = true;
        this.disableFlashPoint = true;
        this.disableNaNo = true;
        this.disableEMSNo = true;
        this.disablePlacard = true;
        this.disableTechnicalName = true;
        this.disableMFAGNo = true;
        this.disablePrecoolingPeriod = true;
        this.disablePackagingGroup = true;
        this.disableDGCargo = true;
        this.disableselectedType = true;
    },
    checkFields: function () {
      this.clearErrorMessages();
      let isValid = true;

      if (!this.commodityCode || !this.commodityCode.trim()) {
        this.commodityCodeError = 'Commodity Code is required!';
        this.entryError.push({ key: "commodityCode", value: this.commodityCodeError });
        isValid = false;
      } else if (this.commodityCode.trim().length > 10) {
        this.commodityCodeError = 'Commodity Code cannot exceed 10 characters!';
        this.entryError.push({ key: "commodityCode", value: this.commodityCodeError });
        isValid = false;
      }
      if (this.commodityDescription.trim().length > 300) {
        this.commodityDescriptionError = 'Commodity Description cannot exceed 300 characters!';
        this.entryError.push({ key: "commodityDescription", value: this.commodityDescriptionError });
        isValid = false;
      }
      if (this.IMO.trim().length > 5) {
        this.IMOError = 'IMO cannot exceed 5 characters!';
        this.entryError.push({ key: "IMO", value: this.IMOError });
        isValid = false;
      }
      if (this.UNNo.trim().length > 8) {
        this.UNNoError = 'UNNo cannot exceed 8 characters!';
        this.entryError.push({ key: "UNNo", value: this.UNNoError });
        isValid = false;
      }
      if (this.NaNo.trim().length > 8) {
        this.NaNoError = 'NaNo cannot exceed 8 characters!';
        this.entryError.push({ key: "NaNo", value: this.NaNoError });
        isValid = false;
      }
      if (this.flashPoint.trim().length > 10) {
        this.flashPointError = 'flashPoint cannot exceed 10 characters!';
        this.entryError.push({ key: "flashPoint", value: this.flashPointError });
        isValid = false;
      }
      if (this.EMSNo.trim().length > 25) {
        this.EMSNoError = 'EMSNo cannot exceed 25 characters!';
        this.entryError.push({ key: "EMSNo", value: this.EMSNoError });
        isValid = false;
      }
      if(this.precoolingPeriod.trim().length > 20) {
        this.precoolingPeriodError = 'Precooling Period cannot exceed 20 characters!';
        this.entryError.push({ key: "precoolingPeriod", value: this.precoolingPeriodError });
        isValid = false;
      }
      if (this.MFAGNo.trim().length > 25) {
        this.MFAGNoError = 'MFAGNo cannot exceed 25 characters!';
        this.entryError.push({ key: "MFAGNo", value: this.MFAGNoError });
        isValid = false;
      }
      if (this.packagingGroup.trim().length > 10) {
        this.packagingGroupError = 'Packaging Group cannot exceed 10 characters!';
        this.entryError.push({ key: "packagingGroup", value: this.packagingGroupError });
        isValid = false;
      }
      if (this.Placard.trim().length > 10) {
        this.placardError = 'Placard cannot exceed 10 characters!';
        this.entryError.push({ key: "Placard", value: this.placardError });
        isValid = false;
      }
      if (this.technicalName.trim().length > 50) {
        this.technicalNameError = 'Technical Name cannot exceed 50 characters!';
        this.entryError.push({ key: "technicalName", value: this.technicalNameError });
        isValid = false;
      }
      return isValid;
    }
  },
  mounted() {
    this.$bus.$on("pageSASControlAccess", x => {
      if (x.page == "Commodity") {
        x.data.forEach(k => {
          let selectedMenu = this.menus.find(m => m["key"] == k["Control"]);
          if (selectedMenu) {
            selectedMenu[k["Properties"].toLowerCase()] =
              k["PropertiesValue"] == "True";
          }
        });
      }
    });
    this.getHazMatCFRList();
    this.getAllCommodityDetails();
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";

.commodity-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  >.right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}

.flex-row {
  display: flex;
  align-items: center;

  >* {
    width: 100%;
  }

  > :not(:first-child) {
    margin-left: 5px;
  }
}
</style>